import FILTER_TYPES from '@/components/query/filter-types';

export default {
    id: 'products',
    version: 1,
    filterSpec: {
        id: {
            type: FILTER_TYPES.text,
        },
        name: {
            type: FILTER_TYPES.text,
        },
        createdTime: {
            type: FILTER_TYPES.datetime,
        },
        updatedTime: {
            type: FILTER_TYPES.datetime,
        },
        invoiceCount: {
            type: FILTER_TYPES.numeric,
        },
        description: {
            type: FILTER_TYPES.text,
        },
        taxCategoryId: {
            type: FILTER_TYPES.text,
        },
        taxCategoryDescription: {
            type: FILTER_TYPES.text,
        },
        requiresShipping: {
            type: FILTER_TYPES.boolean,
        },
        accountingCode: {
            type: FILTER_TYPES.text,
        },
    },
};
